import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, map, tap } from 'rxjs';
import { AuthService } from '../../../auth/auth.service';
import { UserService } from '../../services/user/user.service';
import { ImpersonateService } from '../impersonate.service';

@Injectable({ providedIn: 'root' })
export class ImpersonateResolver {
  private impersonateService = inject(ImpersonateService);
  private authService = inject(AuthService);
  private userService = inject(UserService);

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | any {
    const encodedEmail = encodeURIComponent(route.params.email);
    const email = decodeURIComponent(encodedEmail);

    this.authService.authenticated(false);
    this.impersonateService.setImpersonatedUserEmail(email);
    this.impersonateService.impersonate();

    return this.userService.reload().pipe(
      tap(() => {
        this.authService.authenticated(true);
      }),
      map(() => email),
    );
  }
}
